import React, { useState } from 'react';
import axios from 'axios';
import './Styles/RetailerProductVerification.scss'; // Import your SCSS file
import { Link } from 'react-router-dom';

const RetailerProductVerification = () => {

  const [productCode, setProductCode] = useState('');
  const [verificationResult, setVerificationResult] = useState('');

  const handleVerification = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/products/verifyproduct`, {
        
        productCode
      });
      setVerificationResult(response.data.message);
    } catch (error) {
      console.error('Error verifying product:', error);
      setVerificationResult('Failed to verify product');
    }
  };

  return (
    <div className='RetailerMain'>
    <div className='RetailerXX'>
        <nav className="retailer-navbar">
        <ul>
          <li>
            <Link to={`/Retailer-Home`}>Retailer Home</Link>
          </li>
          <li>
            <Link to={`/Retailer-Home/Add`}>Add Product</Link>
          </li>
          <li>
            <Link to={`/Retailer-Home/SalesDashboard`}>Sales Dashboard</Link>
          </li>
          <li>
          <Link to={`/Retailer-Home/SalePayment`}>Sale Payment</Link>
          </li>
        </ul>
      </nav>
  
    <div className="product-verification-container">
    
      <h2 className="product-verification-title">Retailer Product Verification</h2>
      <div className="product-verification-form">
       
        <label>
          Product Code:
          <input
            className="product-verification-input"
            type="text"
            value={productCode}
            onChange={(e) => setProductCode(e.target.value)}
          />
        </label>
        <button className="product-verification-button" onClick={handleVerification}>Verify Product</button>
        {verificationResult && <p className="product-verification-result">Verification Result: {verificationResult}</p>}
      </div>
    
      </div>
      </div>
    </div>
  );
};

export default RetailerProductVerification;
